module.exports = __webpack_public_path__ + "static/media/bg1.6b1983a2.jpg";